import React, { useState } from 'react';
import { product } from './Datatype';

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  productdata: product;
  files: any[];
}

const ProductView: React.FC<props> = ({ showmodal, setshowmodal, productdata, files }) => {
  const [activeindex, setactiveindex] = useState(0);

  if (showmodal !== "showproductview") return null;

  const productfiles = files.filter(f => f._productid === productdata._id);

  const prev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setactiveindex((activeindex - 1 + productfiles.length) % productfiles.length);
  };

  const next = (e: React.MouseEvent) => {
    e.stopPropagation();
    setactiveindex((activeindex + 1) % productfiles.length);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '560px' }}>
        <div className="modal-header">
          <h3>{productdata.name}</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>

        <div className="modal-body">
          {productfiles.length > 0 ? (
            <div style={{ width: '500px', margin: '0 auto 15px auto', position: 'relative' }}>
              <img 
                src={`/file?_fileid=${productfiles[activeindex]._id}&_adminuserid=${window.APPSETTING.adminuserid}`} 
                alt={productfiles[activeindex].displayname || productdata.name} 
                style={{ width: '500px', height: '350px', objectFit: 'contain', display: 'block', backgroundColor: '#f9f9f9', borderRadius: '4px' }} 
              />

              {productfiles.length > 1 && (
                <>
                  <button 
                    type="button" 
                    onClick={prev} 
                    style={{ position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: '50%', width: '36px', height: '36px', cursor: 'pointer', zIndex: 10 }}
                  >
                    &#10094;
                  </button>
                  <button 
                    type="button" 
                    onClick={next} 
                    style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: '50%', width: '36px', height: '36px', cursor: 'pointer', zIndex: 10 }}
                  >
                    &#10095;
                  </button>
                  <div style={{ textAlign: 'center', marginTop: '6px', fontSize: '12px', color: '#666' }}>
                    {activeindex + 1} / {productfiles.length}
                  </div>
                </>
              )}
            </div>
          ) : (
            <div style={{ width: '500px', height: '180px', margin: '0 auto 15px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0', borderRadius: '4px', color: '#888' }}>
              no images available
            </div>
          )}

          <div style={{ marginBottom: '10px' }}>
            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>cost: </span>
            <span style={{ fontSize: '18px', color: '#2e7d32', fontWeight: 'bold' }}>₹{productdata.price}</span>
          </div>

          <div>
            <strong>description:</strong>
            <p style={{ marginTop: '5px', color: '#444', whiteSpace: 'pre-wrap' }}>
              {productdata.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductView;